import React from 'react';
import styles from './ContactInfo.module.css';

const ContactCard = ({ imageUrl, name, role, email }) => {
  return (
    <div className={styles.contactCard}>
      <div className={styles.contactInfo}>
        <img loading="lazy" src={imageUrl} alt={`${name}'s profile`} className={styles.contactImage} />
        <div className={styles.contactDetails}>
          <h3 className={styles.contactName}>{name}</h3>
          <p className={styles.contactRole}>{role}</p>
          <a href={`mailto:${email}`} className={styles.contactEmail}>{email}</a>
        </div>
      </div>
    </div>
  );
};

export default ContactCard;